import { TableCell, Theme } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { useI18n } from '../../../../../application/language/useI18n';
import { UserProjectsView } from '../../../../../view/user/page/project/list/parts/UserProjectTable';
import { IRiskManagerProjectListDomain } from './domain/IRiskManagerProjectListDomain';

export interface RiskManagerDataInfoInProjectListHeaderProperties {
  userProjectsData: UserProjectsView;
  domain: IRiskManagerProjectListDomain;
}

export const RiskManagerDataInfoInProjectListHeader = observer(
  ({ domain: projectListDomain }: RiskManagerDataInfoInProjectListHeaderProperties) => {
    const classes = useStyles();
    const { translate } = useI18n();
    return (
      <TableCell className={classes.header}>
        {translate('projectPage.userProjectTable.risks')}
        {projectListDomain.isLoadRisks.value && <LinearProgress color="secondary" />}
      </TableCell>
    );
  },
);

export const useStyles = makeStyles((theme: Theme) => ({
  header: {
    width: '200px',
    fontWeight: 'bold',
  },
}));
